import { render, staticRenderFns } from "./watchListSlider.vue?vue&type=template&id=8ffa06da&scoped=true"
import script from "./watchListSlider.vue?vue&type=script&lang=js"
export * from "./watchListSlider.vue?vue&type=script&lang=js"
import style0 from "./watchListSlider.vue?vue&type=style&index=0&id=8ffa06da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffa06da",
  null
  
)

export default component.exports